import { Component } from '@angular/core';
import { Overlay } from "./../commonMap/overlay";

@Component({
    moduleId: module.id,
    selector: 's143g-s143m01',
    templateUrl: './s143g-s143m01.component.html'
})
export class S143gS143m01Component extends Overlay {
    scrndt: any = {};
    scrntm: any = {};
    traindt: any = {'value': '__________'};
    dtwtftr: any = {'value': '_'};
    dtwtdec: any = {'value': '__'};
    msgln: any = {};

    public FIELDS: string[] = ['scrndt', 'scrntm', 'traindt', 'dtwtftr', 'dtwtdec', 'msgln'];
    public LINES: number[] = [1, 2, 3, 6, 22, 7, 24, 9, 11];

    ngAfterViewInit(): void {
    }
}
